import React, { lazy, } from 'react';
import { Switch, Route, Redirect, } from 'react-router-dom';

const MainLayout = lazy(() => import('../layout/Main'));
const DashboardScreen = lazy(() => import('../screens/Dashboard'));
const SpacesScreen = lazy(() => import('../screens/Spaces'));
const BillingEmailSetupScreen = lazy(() => import('../screens/BillingEmailSetup'));
const SpaceScreen = lazy(() => import('../screens/Space'));
const ActivityScreen = lazy(() => import('../screens/Activity'));

const AppRouter = () => {
    return (
        <MainLayout>
            <Switch>
                <Redirect
                    exact
                    from={'/'}
                    to={'/dashboard'}
                />
                <Route
                    exact
                    path={'/dashboard'}
                    component={DashboardScreen}
                />
                <Route
                    exact
                    path={'/spaces'}
                    component={SpacesScreen}
                />
                <Route
                    exact
                    path={'/my-spaces'}
                    component={SpacesScreen}
                />
                <Redirect
                    exact
                    from={'/all-space'}
                    to={'/all-spaces'}
                />
                <Route
                    exact
                    path={'/all-spaces'}
                    component={SpacesScreen}
                />
                <Route
                    exact
                    path={'/users'}
                    component={SpacesScreen}
                />
                <Route
                    exact
                    path={'/team-management'}
                    component={SpacesScreen}
                />
                <Route
                    exact
                    path={'/payroll-calendar'}
                    component={SpacesScreen}
                />
                <Route
                    exact
                    path={'/billing'}
                    component={SpacesScreen}
                />
                <Route
                    exact
                    path={'/billing-reports'}
                    component={SpacesScreen}
                />
                <Route
                    exact
                    path={'/billing-email-setup'}
                    component={BillingEmailSetupScreen}
                />
                <Redirect
                    exact
                    from={'/archived-space'}
                    to={'/archived-spaces'}
                />
                <Route
                    exact
                    path={'/archived-spaces'}
                    component={SpacesScreen}
                />
                <Route
                    path={'/space/:id'}
                    component={SpaceScreen}
                />
                <Route
                    path={['/activity/:id/discussion/:discussion_id', '/activity/:id']}
                    component={ActivityScreen}
                />
                <Redirect to='/' />
            </Switch>
        </MainLayout>
    )
}

export default AppRouter;
